/*!
 * angular-translate - v2.15.2 - 2017-06-22
 *
 * Copyright (c) 2017 The angular-translate team, Pascal Precht; Licensed MIT
 */
!(function (a, b) {
  'function' == typeof define && define.amd
    ? define(['messageformat'], function (a) {
        return b(a);
      })
    : 'object' == typeof module && module.exports
    ? (module.exports = b(require('messageformat')))
    : b(a.MessageFormat);
})(this, function (a) {
  function b() {
    'use strict';
    var a;
    (this.messageFormatConfigurer = function (b) {
      a = b;
    }),
      (this.$get = [
        '$translateSanitization',
        '$cacheFactory',
        'TRANSLATE_MF_INTERPOLATION_CACHE',
        function (b, d, e) {
          return c(b, d, e, a);
        },
      ]);
  }
  function c(b, c, d, e) {
    'use strict';
    var f = {},
      g = c.get(d),
      h = new a('en');
    return (
      angular.isFunction(e) && e(h),
      g || (g = c(d)),
      g.put('en', h),
      (f.setLocale = function (b) {
        (h = g.get(b)) || ((h = new a(b)), angular.isFunction(e) && e(h), g.put(b, h));
      }),
      (f.getInterpolationIdentifier = function () {
        return 'messageformat';
      }),
      (f.useSanitizeValueStrategy = function (a) {
        return b.useStrategy(a), this;
      }),
      (f.interpolate = function (a, c, d, e) {
        (c = c || {}), (c = b.sanitize(c, 'params', e));
        var f = g.get('mf:' + a);
        if (!f) {
          for (var i in c)
            if (c.hasOwnProperty(i)) {
              var j = parseInt(c[i], 10);
              angular.isNumber(j) && '' + j === c[i] && (c[i] = j);
            }
          (f = h.compile(a)), g.put('mf:' + a, f);
        }
        var k = f(c);
        return b.sanitize(k, 'text', e);
      }),
      f
    );
  }
  return (
    angular
      .module('pascalprecht.translate')
      .constant('TRANSLATE_MF_INTERPOLATION_CACHE', '$translateMessageFormatInterpolation')
      .provider('$translateMessageFormatInterpolation', b),
    (c.displayName = '$translateMessageFormatInterpolation'),
    'pascalprecht.translate'
  );
});
